import React, { useState } from 'react';
import { LinkPrompt } from './LinkPrompt';
import { useView } from '../../hooks/use-view';
import { useLink } from '../../hooks/use-link';

export const LinkButton = ({ className, placeholder, children }) => {
  const view = useView();

  const { link, openLink, closeLink, updateLink } = useLink();

  const [open, setOpen] = useState(false);

  const handleBtnClick = e => {
    e.preventDefault();
    if (view?.state) {
      openLink(view.state, view.dispatch);
    }
  };

  const onSubmit = updatedLink => {
    if (view?.state && updatedLink) {
      updateLink(view.state, view.dispatch, updatedLink);
    }
  };

  return (
    <>
      <button
        className={className}
        onClick={handleBtnClick}
        placeholder={placeholder}
      >
        {children}
      </button>

      {link && (
        <LinkPrompt link={link} onSubmit={onSubmit} onCancel={closeLink} />
      )}
    </>
  );
};
